import React, { FC, useEffect, useState } from "react";
import {
  CircularProgress,
  Grid,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Download as DownloadIcon,
  Image as ImageIcon,
  FilePdfBox as PdfIcon,
  TextBox as DocumentIcon,
  FileExcel as ExcelIcon,
  FileWord as WordIcon,
} from "mdi-material-ui";
import { snack } from "components/GlobalSnackbar";
import { getError, loadS3File } from "utils";
import { useMobile } from "hooks/useMobile";
import Grid2 from "@mui/material/Unstable_Grid2";
import { api } from "configs";
import { IArquivo } from "@deltasge/marauders-map";

export const ChatDocument: FC<{ src: string }> = ({ src }) => {
  const [arquivo, setArquivo] = useState<IArquivo>();
  const [loading, setLoading] = useState(false);

  const isSm = useMobile("sm");

  useEffect(() => {
    let ativo = true;
    (async () => {
      try {
        setLoading(true);
        const { data } = await api.get<[IArquivo[], number]>("arquivo", {
          params: {
            where: {
              caminhoArquivo: src,
            },
          },
        });
        const [arquivos] = data;
        const arquivo = arquivos.at(0);
        if (arquivo) {
          const { error, processed } = await loadS3File(arquivo.caminhoArquivo);
          if (error) {
            throw new Error(error);
          }
          if (!processed) {
            throw new Error("Erro ao processar o arquivo");
          }
          arquivo.caminhoArquivo = processed;
          if (ativo) setArquivo(arquivo);
        }
      } catch (error) {
        if (ativo) snack.error(getError(error));
      } finally {
        setLoading(false);
      }
    })();
    return () => {
      ativo = false;
    };
  }, []);

  const isImage = [
    "jpg",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "apng",
    "png",
    "bmp",
    "webp",
    "avif",
    "gif",
    "svg",
  ].includes((src.split(".").pop() ?? "").toLocaleLowerCase());
  const isPdf = src.toLocaleLowerCase().endsWith("pdf");
  const idDoc = ["doc", "docx", "odt"].includes(
    (src.split(".").pop() ?? "").toLocaleLowerCase()
  );
  const isXls = ["xls", "xlsx"].includes(
    (src.split(".").pop() ?? "").toLocaleLowerCase()
  );

  return (
    <ListItemButton
      dense={isSm}
      onClick={
        arquivo
          ? () => {
              window.open(arquivo.caminhoArquivo, "_blank");
            }
          : undefined
      }
      disabled={loading}
    >
      <Grid2 container sx={{ justifyContent: "space-between" }}>
        <Grid item xs="auto" zeroMinWidth>
          <ListItemIcon>
            {isImage ? (
              <ImageIcon />
            ) : isPdf ? (
              <PdfIcon />
            ) : idDoc ? (
              <WordIcon />
            ) : isXls ? (
              <ExcelIcon />
            ) : (
              <DocumentIcon />
            )}
          </ListItemIcon>
        </Grid>
        <Grid item xs zeroMinWidth>
          <ListItemText
            primary={arquivo?.nomeArquivo}
            primaryTypographyProps={{ noWrap: true }}
          />
        </Grid>
        <Grid item xs="auto" zeroMinWidth>
          <ListItemIcon sx={{ justifyContent: "right" }}>
            {loading && (
              <CircularProgress
                sx={({ spacing }) => ({
                  width: spacing(3).concat(" !important"),
                  height: spacing(3).concat(" !important"),
                })}
              />
            )}
            {!loading && <DownloadIcon />}
          </ListItemIcon>
        </Grid>
      </Grid2>
    </ListItemButton>
  );
};
